


























































































import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { EPLModule } from '../store/eplmodule'
// import { GeoSearchControl, EsriProvider } from 'leaflet-geosearch'
// import '../../node_modules/leaflet-geosearch/dist/geosearch.css'
import L from 'leaflet'
import { LMap } from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
// type D = Icon.Default & {
//   _getIconUrl: string
// };
// delete (Icon.Default.prototype as D)._getIconUrl
// Icon.Default.mergeOptions({
//   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//   iconUrl: require('leaflet/dist/images/marker-icon.png'),
//   shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// })

@Component({
  name: 'RouteBuilder',
  components: {
    LMap: LMap
  }
})
export default class RouteBuilder extends Vue {
  @Prop() route!: string
  @Prop() len!: string
  @Prop() required!: string
  @Prop() disabled!: string
  @Prop() signed!: boolean
  @Prop() label!: string

  showMapDialog = false
  map = {} as L.Map
  coordinates = ''
  canSave = false

  showHistoryRoute = false
  HistoryRoute = [] as Array<{name: string, id: number}>
  HistoryRouteRes = [] as Array<number>
  buttonLoading = false

  @Emit('update:route')
  update (val: string) {
    return val
  }

  get value () {
    return this.route
  }

  set value (val) {
    this.update(val)
  }

  private saveHistoryRoute () {
    let res = ''
    this.HistoryRouteRes.forEach(r => {
      this.HistoryRoute.forEach(h => {
        if (h.id === r) {
          res += `${h.name.substring(22, h.name.lastIndexOf(' ('))}\n`
        }
      })
    })
    const idx = EPLModule.DictIdx('DriverTasks')
    EPLModule.dicts[idx].currentRow.route = res
    this.showHistoryRoute = false
    this.buttonLoading = false
  }

  private save () {
    EPLModule.getAzotNavi(this.coordinates)
      .then((response: any) => {
        this.showMapDialog = false
        let res = ''
        response.data.forEach((e: any) => {
          if (res !== '') {
            res += '\n'
          }
          if (e.address.building === undefined) res += `${e.address.city}, ${e.address.road}, ${e.address.house_number}`
          else res += `${e.address.building}`
        })
        this.value = res.replace(/undefined/ig, '')
      })
  }

  onClickMap () {
    this.initPoints()
    this.showMapDialog = true
  }

  onClickHistory () {
    this.buttonLoading = true
    const idx = EPLModule.DictIdx('DriverTasks')
    const idxEPL = EPLModule.DictIdx('EPL')
    const begin = EPLModule.dicts[idx].currentRow.driverarrivedtime
    const end = EPLModule.dicts[idx].currentRow.driverdeparturetime
    let transport = EPLModule.dicts[idxEPL].currentRow.transport
    if (transport === '') transport = '-1'
    EPLModule.getHistoryRoute({ begin: begin, end: end, transport: transport })
      .then((res: any) => {
        this.HistoryRoute.splice(0, this.HistoryRoute.length)
        const data = new Map(Object.entries(res.data))
        let i = 0
        data.forEach((title: any, time: string) => {
          this.HistoryRouteRes.push(i)
          this.HistoryRoute.push({ name: `${time} - ${title}`, id: i })
          i++
        })
        // res.data.forEach((r: string, i: number) => {
        //   this.HistoryRouteRes.push(i)
        //   this.HistoryRoute.push({ name: r, id: i })
        // })
        this.showHistoryRoute = true
        this.buttonLoading = false
      })
      .catch(() => {
        this.buttonLoading = false
      })
  }

  private initPoints () {
    if (this.map.options !== undefined) {
      this.mapDeleteMarkers()
      // const provider = new EsriProvider()
      // если маршрут заполнен, отметим точки и покажем их
      const points = this.value.split('\n')
      let len = 0
      points.forEach((p: string) => {
        if (p !== '') len++
      })
      if (len > 0) {
        const markers = [] as Array<L.LatLng>
        for (let x = 0; x < points.length; x++) markers.push(new L.LatLng(0, 0))
        const promises = [] as any
        points.forEach((p: string, i: number) => {
          if (p !== '') {
            promises.push(EPLModule.getLatLon(p).then((res: any) => {
              if (res.data.length > 0) {
                markers[i].lat = res.data[0].lat
                markers[i].lng = res.data[0].lon
                console.log(res.data)
              }
            }))
            // promises.push(provider.search({ query: p })
            //   .then((res: any) => {
            //     if (res.length > 0) {
            //       markers[i].lat = res[0].y
            //       markers[i].lng = res[0].x
            //     }
            //   }))
          }
        })
        this.map.dragging.disable()
        Promise.all(promises).then(() => {
          markers.forEach(m => {
            if (m.lat !== 0 && m.lng !== 0) this.addMarker(m)
          })
          this.mapBoundMarkers()
          this.map.dragging.enable()
        })
      } else {
      // иначе покажем на карте АЗОТ
        const latlng = {} as L.LatLng
        latlng.lat = 55.34779145740453
        latlng.lng = 85.99807977676393
        this.map.setView(latlng, 15)
      }
    }
  }

  private async onMapReady () {
    const map = this.$refs.myMap as any
    this.map = map.mapObject as L.Map
    L.control.scale().addTo(this.map)
    // const provider = new EsriProvider()
    // const searchControl = new GeoSearchControl({
    //   provider: provider,
    //   style: 'bar',
    //   retainZoomLevel: true,
    //   animateZoom: true,
    //   autoClose: true,
    //   searchLabel: 'Адрес для поиска',
    //   keepResult: true
    // })
    // this.map.addControl(searchControl)
    this.initPoints()

    // const AZOT = L.tileLayer('http://navi15.azot.kmr/osm/{z}/{x}/{y}.png')
    const OSM = L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png')
    const googleStreets = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    })
    const googleHybrid = L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    })
    const googleSat = L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    })
    const googleTerrain = L.tileLayer('http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    })
    L.control.layers({ OSM, googleStreets, googleHybrid, googleSat, googleTerrain }).addTo(this.map)
    this.map.addLayer(OSM)

    this.map.on('geosearch/showlocation', this.onMapShowLocation)
    this.map.on('dblclick', this.onMapClick)
    this.map.doubleClickZoom.disable()
    this.map.invalidateSize()
  }

  private mapBoundMarkers () {
    const markerPoint = [] as Array<L.LatLng>
    this.map.eachLayer(l => {
      if (l instanceof L.Marker) {
        if (l.options.draggable) {
          markerPoint.push(l.getLatLng())
        }
      }
    })
    if (markerPoint.length === 1) {
      let zoom = this.map.getZoom()
      if (zoom < 15) zoom = 15
      this.map.setView(markerPoint[0], zoom)
    }
    if (markerPoint.length > 1) {
      const bounds = L.latLngBounds(markerPoint)
      this.map.fitBounds(bounds)
    }
  }

  private mapDeleteMarkers () {
    this.map.eachLayer(l => {
      if (l instanceof L.Polyline) {
        l.remove()
      }
      if (l instanceof L.Marker) {
        // if (l.options.draggable) {
        l.remove()
        // }
      }
    })
    this.calculateResult()
  }

  private onMarkerDragend (e: any) {
    const points = [] as any[]
    this.map.eachLayer(l => {
      if (l instanceof L.Polyline) {
        l.remove()
      }
      if (l instanceof L.Marker) {
        points.push(l.getLatLng())
      }
    })
    L.polyline(points).addTo(this.map)
    this.calculateResult()
  }

  private onMapShowLocation (e: any) {
    console.log(e.location)
    const latlng = {} as L.LatLng
    latlng.lat = e.location.y
    latlng.lng = e.location.x
    this.addMarker(latlng)
  }

  private addMarker (latlng: L.LatLng) {
    let count = 1
    let prev
    this.map.eachLayer(l => {
      if (l instanceof L.Marker) {
        if (l.options.draggable) count++
        prev = l.getLatLng()
      }
    })
    let marker = {} as L.Marker
    marker = L.marker(latlng, { draggable: true, icon: this.getIcon('red') }).addTo(this.map).bindPopup(`Точка: ${count}`).openPopup()
    if (prev !== undefined) L.polyline([prev, latlng]).addTo(this.map)
    marker.on('dragend', this.onMarkerDragend)
    this.calculateResult()
  }

  private getIcon (color: string): L.DivIcon {
    const markerHtmlStyles = `position:relative;left:4px;font-size:40px;color:${color};`
    const icon = L.divIcon({
      className: `pin-${color}`,
      iconAnchor: [20, 40],
      popupAnchor: [0, -30],
      html: `<span style="${markerHtmlStyles}" class="fas fa-map-marker-alt"></span>`
    })
    return icon
  }

  private onMapClick (e: any) {
    this.addMarker(e.latlng)
  }

  private calculateResult () {
    let count = 0
    let res = ''
    this.map.eachLayer(l => {
      if (l instanceof L.Marker) {
        count++
        res += `${l.getLatLng().lat},${l.getLatLng().lng};`
      }
    })
    this.coordinates = res
    this.canSave = count > 1
  }
}
